// extracted by mini-css-extract-plugin
module.exports = {"container":"bubble_container__37sgY"};